import { Injectable, forwardRef } from '@angular/core';

import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { COMPONENT_BASE } from 'hisng';

/* provider manager for dynamic-component rendering */
@Injectable()
export class ProviderManager {

    /* Component provider for usage of dynamic attributes */
    public static getComponentProvider( componentReference: any ) {
        return [
            {
                provide: COMPONENT_BASE,
                useExisting: forwardRef( () => componentReference )
            }
        ];
    }

    /* Component provider for control value accessor field validation */
    public static getValueAccessorProvider( componentReference: any ) {
        return [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => componentReference),
                multi: true
            }
        ];
    }
}

